//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userHeader from '~/components/login/userHeader.vue'
import userTabs from '~/components/login/userTabs.vue'
import userCountry from '~/components/login/userCountry.vue'
import wikiGeet from '~/components/common/wikiGeet.vue'
import userVerificacode from '~/components/login/userVerificacode.vue'
import userVoicevercode from '~/components/login/userVoicevercode.vue'
import userThreparty from '~/components/login/userThreparty.vue'
import userGraphical from '~/components/login/userGraphical.vue'
import { assign } from '~/assets/js/utils.js'
export default {
  components: {
    'user-header': userHeader,
    'user-tabs': userTabs,
    'user-country': userCountry,
    'wiki-geet': wikiGeet,
    'user-verificacode': userVerificacode, // 验证码
    'user-voicevercode': userVoicevercode, // 语音验证码
    'user-threparty': userThreparty, // 三方登录
    'user-graphical': userGraphical // 图形验证码
  },
  data () {
    return {
      firstLoad: true, // 是否为首次加载该组件
      tabs: [
        { name: this.$t('22517'), type: 1 },
        { name: this.$t('22518'), type: 2 }
      ],
      mobileNumber: 2, // 点击tab栏状态改变：1为手机验证码，2为电子邮箱/手机号，3为验证码验证
      verificationCode: 1, // 1为获取手机验证码，2为获取语音验证码
      // 验证码登录
      roTade: false, // 国家点击下拉框状态
      phoneSize: false, // 请输入手机号样式漂浮状态
      showDrag: false, // 是否展示极验拖拽框
      clearButton: false, // 是否展示关闭按钮
      phoneLoading: false, // 加载动画显示
      // 邮箱/手机号登录
      emailNumber: false, // 电子邮件或手机号样式状态
      emailpasswordNumber: false, // 电子邮件或手机号密码样式状态
      openState: false, // 手机号邮箱登录密码状态切换 true 显示 false 关闭为密码模式
      // 登录数值绑定
      signin: {
        cellhoneNumber: '', // 验证码登录手机号绑定
        formatError: '', // 手机号验证码登录错误提示
        mailorPhone: '', // 邮箱or手机号账号绑定
        mailorPhoneword: '', // 邮箱手机号密码登录
        mailorError: '', // 账号密码登录错误提示
        requestId: '', // 验证码发送后的requestId
        isregistered: null // 手机号是否注册
      },
      voiceState: true, // 是否展示语音验证
      countOrnot: true, // 是否展示倒计时
      isVercode: false, // 是否校验验证码
      product: 'popup', // 极验展示效果
      canIskip: false // 是否出现跳过
    }
  },
  computed: {
    // 完整的域名
    fullDomain () {
      return this.$store.state.fullHost
    },
    // 标题
    title () {
      switch (this.mobileNumber) {
        case 1:
        case 2:
          return this.$t('TYY_000242') // 登录
        case 3:
          return this.$t('TYY_000262') // 验证码
        case 4:
          return this.$t('22573') // 语音验证
        default:
          return ''
      }
    },
    // 手机号相关信息（国旗、手机区号、手机号等）
    phoneCode () {
      return this.$store.state?.phoneInfo || {}
    }
  },
  watch: {
    // 监听国家下拉框
    roTade (newV) {
      if (!newV || !this.firstLoad) return false // 收起或非首次展开下拉框时，不执行后续操作
      this.firstLoad = false // 当首次展开下拉框时，需要执行以下操作，后续无需执行
      this.$nextTick(() => {
        this.$refs?.userCountry?.getHeight()
      })
    },
    // 监听手机号输入框
    'signin.cellhoneNumber' (newV) {
      if (newV && this.mobileNumber == 1)
        this.clearButton = true // 清空按钮，下一步按钮
      else if (!newV) this.clearButton = false // 清空按钮，下一步按钮
    },
    // 监听邮箱输入框
    'signin.mailorPhone' (newV) {
      if (newV && this.signin.mailorPhoneword && this.mobileNumber == 2)
        this.clearButton = true // 清空按钮，下一步按钮
      else if (!newV) this.clearButton = false // 清空按钮，下一步按钮
    },
    'signin.mailorPhoneword' (newV) {
      if (newV && this.signin.mailorPhone && this.mobileNumber == 2)
        this.clearButton = true // 清空按钮，下一步按钮
      else if (!newV) this.clearButton = false // 清空按钮，下一步按钮
    },
    phoneCode () {
      this.signin.formatError = ''
    }
  },
  created () {
    this.mobileNumber = this.fullDomain?.includes('wikifx') ? 2 : 1
  },
  mounted () {
    document.addEventListener('click', this.coutryClose)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.coutryClose)
  },
  methods: {
    // 更换手机区号
    countryChangeFn (obj = {}) {
      this.$store.commit('setVal', { phoneInfo: obj })
      this.roTade = false
    },
    // 清空输入框内容
    closeFn () {
      assign(this.signin, { cellhoneNumber: '', formatError: '' }) // 手机输入内容为空/手机错误提示为空
      this.phoneSize = this.phoneLoading = false // 请输入手机号样式为false，加载动画为false
    },
    threSwitch () {
      this.switstat(this.fullDomain?.includes('wikifx') ? 2 : 1)
      this.$emit('loginSwitch', 2)
    },
    loginSwitch (i = 1) {
      this.mobileNumber = i
    },
    jumpgender () {
      this.$emit('verCode', '')
      this.$emit('setRequestId', this.signin.requestId)
      this.$emit('cellphoneNumber', this.signin.cellhoneNumber)
      this.$emit('loginSwitch', 2) // 切换注册流程
    },
    // 获取验证码之前的操作
    getPhonecode (data = {}) {
      this.showDrag = false
      this.sendVCode(data)
    },
    // 极验错误
    geetError () {
      this.showDrag = false // 关闭极验框
      this.mobileNumber = 5 // 展示图形验证码
    },
    // 点击非组件区域关闭下拉框
    coutryClose (e = {}) {
      if (!this.$el.contains(e?.target)) this.roTade = false
    },
    // tab栏切换
    switstat (i = 1) {
      assign(this.signin, {
        cellhoneNumber: '',
        mailorPhone: '',
        mailorPhoneword: '',
        formatError: '',
        mailorError: ''
      }) // 手机号验证码登录绑定清空、邮箱手机号密码登录绑定清空、邮箱or手机号账号绑定清空
      this.phoneLoading = false
      this.phoneSize =
        this.emailNumber =
        this.emailpasswordNumber =
        this.showDrag =
          false // 请输入手机号样式状态false、电子邮件或手机号样式状态false、电子邮件或手机号密码样式状态false
      this.mobileNumber = i // 显示状态：1为手机验证码，2为手机号/邮箱登录
      this.roTade = false
    },
    // 下一步/登录
    logoIn () {
      const {
        cellhoneNumber = '',
        mailorPhone = '',
        mailorPhoneword = ''
      } = this.signin
      if (this.mobileNumber == 1 && cellhoneNumber)
        this.getVercode() // 手机验证码形式登录
      else if (this.mobileNumber == 2 && mailorPhone && mailorPhoneword)
        this.accpassLogin()
    },
    // 校验手机号格式后获取验证码
    getVercode () {
      const { cellhoneNumber = '' } = this.signin
      if (!cellhoneNumber) {
        assign(this.signin, { formatError: this.$t('22520') })
        return false
      }
      const myreg =
        this.phoneCode.code == '0086'
          ? /^[1][3,4,5,6,7,8,9][0-9]{9}$/
          : /^.{5,20}$/
      if (myreg.test(cellhoneNumber)) {
        assign(this.signin, { formatError: '' }) // 验证成功则错误消息清空
        this.numberRis() // 手机号校验
      } else assign(this.signin, { formatError: this.$t('22521') })
    },
    // 手机校验是否注册之后是否发送验证码国内国际逻辑
    async numberRis () {
      const { cellhoneNumber = '' } = this.signin
      const { code = '' } = this.phoneCode
      if (!cellhoneNumber || this.isCheckReq) return false // 接口请求中，不执行后续操作
      this.isCheckReq = true // 请求开始
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userCheckphone({
          areaCode: code,
          phoneNumber: cellhoneNumber
        }) // 校验手机号是否注册
        console.log('这里33')
        if (!succeed) return this.$toast.error(extra) // 数据错误
        assign(this.signin, { isregistered: result?.isregister }) // 该手机号是否注册
        if (result?.isregister) this.showDrag = true // 手机注册过则出现极验
        else if (code == '0086') {
          // 手机未注册为86则出现极验
          this.canIskip = true // 未注册且为0086则出现跳过
          this.showDrag = true // 极验框展示
        } else {
          // 不为86则直接进入注册流程
          this.$emit('cellphoneNumber', cellhoneNumber) // 发送当前输入的手机号
          this.$emit('loginSwitch', 2) // 切换注册流程
        }
      } catch (err) {}
      this.isCheckReq = false // 请求结束
    },
    // 极验成功后发送验证码
    async sendVCode (data = {}) {
      console.log(5555555, '1/2')
      const { cellhoneNumber = '' } = this.signin
      const { code = '' } = this.phoneCode
      if (!cellhoneNumber) return false
      this.showDrag = false // 隐藏拖拽框
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: code, phone: cellhoneNumber, languageCode: this.currLangCode(), msgType: (this.verificationCode == 1 ? 0 : 1), smsBusinessType: 1, applicationType: 7, GeetestValidate: data.geetest_validate, GeetestChallenge: data.geetest_challenge }) // 发送验证码/语音验证码

      const res = await this.$api.common
        .v3Client(
          {
            Routes: 'usercenter$sendcodegeettest4'
          },
          {
            areaCode: code,
            phone: cellhoneNumber,
            languageCode: this.currLangCode(),
            msgType: this.verificationCode == 1 ? 0 : 1,
            userId: this.userId,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        assign(this.signin, { requestId: rest?.requestid })
        this.verificationCode = 1 // 修改为验证码获取
        this.mobileNumber = 3 // 跳转验证码
      } else {
        return this.$toast.error(rest?.extra || 'error')
      }

      // if (!succeed) return this.$toast.error(extra) // 数据错误
      // assign(this.signin, { requestId: result?.requestid })
      // this.verificationCode = 1 // 修改为验证码获取
      // this.mobileNumber = 3 // 跳转验证码
    },
    // 图形验证成功后发送验证码
    async setVercode (data = '') {
      console.log(6666666, '1/2')
      const { cellhoneNumber = '' } = this.signin
      const { code = '' } = this.phoneCode
      if (!cellhoneNumber) return false
      this.showDrag = false // 隐藏拖拽框
      // const { succeed = false, extra = '', result = {} } = await this.$api.login.userVercode({ areaCode: code, phone: cellhoneNumber, languageCode: this.currLangCode(), msgType: (this.verificationCode == 1 ? 0 : 1), smsBusinessType: 1, applicationType: 7, GeetestValidate: '', GeetestChallenge: '', graphCode: data })
      const res = await this.$api.common
        .v3Client(
          {
            Routes: 'usercenter$sendcodegeettest4'
          },
          {
            areaCode: code,
            phone: cellhoneNumber,
            languageCode: this.currLangCode(),
            msgType: this.verificationCode == 1 ? 0 : 1,
            userId: this.userId,
            smsBusinessType: 1,
            applicationType: 7,
            GeetestValidate: data.geetest_validate,
            GeetestChallenge: data.geetest_challenge,
            captcha_output: data.captcha_output,
            lot_number: data.lot_number,
            pass_token: data.pass_token,
            gen_time: data.gen_time
          }
        )
        .catch(() => {
          console.log('sendcodegeettest4')
        })

      const rest = res?.usercenter?.sendcodegeettest4
      console.log('rest::: ', rest)
      if (rest?.success) {
        assign(this.signin, { requestId: rest?.requestid })
        this.mobileNumber = 3 // 跳转验证码
      } else {
        return this.$toast.error(rest?.extra || 'error')
      }

      // if (!succeed) return this.$toast.error(extra) // 数据错误
      // assign(this.signin, { requestId: result?.requestid })
      // this.mobileNumber = 3 // 跳转验证码
    },
    // 跳转语音获取验证码
    voiceVerification () {
      this.mobileNumber = 4 // 修改为语音验证码弹框
    },
    // 语音获取验证码
    voiceTran () {
      this.countOrnot = false // 展示获取验证码
      this.mobileNumber = 3 // 修改为手机号弹框
      this.verificationCode = 2 // 修改为语音验证码获取
      this.$nextTick(() => {
        this.$refs?.userverificacode?.getweebgeet() // 调用极验
      })
    },
    // 语音获取取消
    voiceClose () {
      this.countOrnot = false // 取消倒计时
      this.mobileNumber = 3 // 跳转为验证码
    },
    // 验证码成功之后登录
    async getUsertion (code = '') {
      const {
        isregistered = false,
        cellhoneNumber = '',
        requestId = ''
      } = this.signin
      const { ip = '' } = this.$store.state
      if (isregistered) {
        // 判断该手机号是否注册，若注册则直接登录
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userQuicklogin({
          areaCode: this.phoneCode?.code,
          phone: cellhoneNumber,
          msgCode: code,
          requestId,
          version: 124,
          applicationType: 7,
          countryCode: this.phoneCode?.countryCode,
          languageCode: this.currLangCode(),
          ip
        })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.accessCookie(result) // 加密cookie存cookie
      } else {
        // 校验验证码是否正确
        const { succeed = false, extra = '' } =
          await this.$api.login.userVerifysms({
            AreaCode: this.phoneCode?.code,
            PhoneNumber: cellhoneNumber,
            Smscode: code,
            ApplicationType: 7,
            ValidateSmsCodeType: 3,
            LanguageCode: this.currLangCode()
          })
        if (!succeed) return this.$toast.error(extra) // 数据错误
        this.$emit('verCode', code)
        this.$emit('setRequestId', requestId)
        this.$emit('cellphoneNumber', cellhoneNumber)
        this.$emit('loginSwitch', 2) // 切换注册流程
      }
    },
    // 账号密码登录
    async accpassLogin () {
      const { ip = '' } = this.$store.state
      const { mailorPhone = '', mailorPhoneword = '' } = this.signin
      if (this.phoneLoading) return false // 接口请求中，不执行后续操作
      this.phoneLoading = true // 请求开始
      try {
        const {
          succeed = false,
          extra = '',
          result = {}
        } = await this.$api.login.userAccpass({
          account: mailorPhone,
          password: mailorPhoneword,
          version: 124,
          loginType: mailorPhone.includes('@') ? 1 : 0,
          applicationType: 7,
          countryCode: this.phoneCode?.countryCode,
          languageCode: this.currLangCode(),
          ip
        })
        this.phoneLoading = false // 请求结束
        if (!succeed) return (this.signin.mailorError = extra) // 数据错误
        assign(this.signin, { mailorError: '' })
        this.accessCookie(result) // 加密cookie存cookie
      } catch (err) {}
      this.phoneLoading = false // 请求结束
    },
    // 加密cookie
    async accessCookie (obj = {}) {
      const {
        userId = '',
        nick = '',
        showNickName = '',
        avatar = '',
        showAvataraddress = '',
        EnterpriseCode = ''
      } = obj
      console.log('EnterpriseCode::: ', EnterpriseCode)
      if (EnterpriseCode) this.setCookie('EnterpriseCode', EnterpriseCode)
      const {
        succeed = false,
        extra = '',
        result = {}
      } = await this.$api.login.userEncryption({
        userId,
        nick: showNickName || nick,
        avatar: showAvataraddress || avatar
      })
      if (!succeed) return this.$toast.error(extra) // 数据错误
      this.$store.commit('setVal', {
        cookieVal: result?.Value,
        simpleUser: {
          userId,
          nick: showNickName || nick,
          avatar: showAvataraddress || avatar
        }
      })
      if (this.fullDomain?.includes('wikifx'))
        this.setCookie('DJkdikKMG', result?.Value)
      else if (this.fullDomain?.includes('fxeye'))
        this.setCookie('ViLartidlakd', result?.Value)
      else {
        this.$cookies.set('WsdsfgDGdagYms', result?.Value)
        const postdata = { op_type: 'setCookie', url: '', parm: result?.Value }
        window?.parent?.postMessage(postdata, '*')
      }
      this.$emit('close')
    },
    // 存储cookie
    setCookie (key = '', val = '') {
      this.$cookies.set(key, val, this.$store.getters.cookConf)
      console.log(
        'this.$store.getters.cookConf::: ',
        this.$store.getters.cookConf
      )
    }
  }
}
